<template>
  <div data-qa="tab-rating">
    <div class="text-left h5-headline">
      {{ $t('Common.EstimatesTermsOfSite') }}
    </div>
    <sDivider class="mt-2"/>
    <v-card class="mt-5 pa-5 main__light_green d-flex">
      <div class="col-5 text-left pt-1 pl-1">
        <div class="criteria-title text-upperrcase">
          {{ $t('Tenders.Rating') }}
        </div>
        <div class="criteria-value">
          <span>{{ $n(supplierRatings ? supplierRatings.totalScore || itemRating || 0 : itemRating || 0, 'decimal') }}</span>
          <span>{{ $t('Common.OutOf ') }}</span>
          <span>{{ $n(5, 'decimal') }}</span>
        </div>
        <div
          v-if="supplierRatings"
          class="h8-text grey--text">
          {{ supplierRatings.scoresCount }} {{ $tc('Common.ratings', supplierRatings.scoresCount) }}
        </div>
        <div class="mt-1 pr-7 h8-text grey--text">
          {{ $t('Common.HintCalcOverallRating') }}.
        </div>
      </div>
      <div
        v-if="evaluationCriterias"
        class="row pt-11 pb-7">
        <div
          v-for="evaluationCriteria in evaluationCriterias"
          :key="evaluationCriteria.id"
          class="criteria-evaluation"
          :data-qa="`criteria-evaluation-${evaluationCriteria.id}`">
          <div
            class="criteria-evaluation-title"
            :data-qa="`criteria-evaluation-${evaluationCriteria.id}-title`">
            {{ evaluationCriteria.title }}
          </div>
          <div
            class="criteria-evaluation-value"
            :data-qa="`criteria-evaluation-${evaluationCriteria.id}-value`">
            {{ evaluationCriteria.value }}
          </div>
        </div>
      </div>
    </v-card>
    <div class="mt-7 text-left h5-headline">
      {{ $t('Common.ScoreFromMyCompany') }}
    </div>
    <sDivider class="mt-5"/>
    <v-data-table
      calculate-widths
      class="mt-5 elevation-0 main__light_green table-rating"
      data-qa="rating-table"
      disable-pagination
      fixed-header
      :headers="headers"
      :hide-default-footer="true"
      :item-key="'createDate'"
      :items="sliced_items"
      :loading-text="$t('Tenders.Loading')"
      :no-data-text="$t('Tenders.NoData')"
      :no-results-text="$t('Tenders.NoData')">
      <template #item="{ item, index }">
        <tr :data-qa="`rating-table-${index}`">
          <td
            class="text-start"
            :data-qa="`rating-table-${index}-createDate`">
            {{ item.createDate }}
          </td>
          <td
            class="text-start"
            :data-qa="`rating-table-${index}-fullName`">
            {{ item.fullName }}
          </td>
          <td
            class="text-start"
            :data-qa="`rating-table-${index}-totalScore`">
            {{ item.totalScore || '-' }}
          </td>
          <template v-if="!item.evaluationCriterias || item.evaluationCriterias.length > 0">
            <td
              v-for="typeRating in typeRatings_sync"
              :key="`${item.fullName}-${typeRating.id}`"
              class="text-start"
              :data-qa="`rating-table-${index}-typeRating-${typeRating.id}`">
              {{ item[`rating${typeRating.id}`] }}
            </td>
          </template>
          <td class="text-start">
            <v-tooltip
              v-if="item.remark"
              top>
              <template #activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on">
                  <sIcon
                    :data-qa="`rating-table-${index}-icon`"
                    type="comment"/>
                </span>
              </template>
              <div
                class="h8-text text-left mx-3"
                :data-qa="`rating-table-${index}-remark`">
                {{ item.remark }}
              </div>
            </v-tooltip>
            <sIcon
              v-else
              color="grey"
              :data-qa="`rating-table-${index}-icon`"
              type="comment"/>
          </td>
        </tr>
      </template>
    </v-data-table>
    <InfinityUpdater
      :action="infinityLoad"
      :active="ratingItems.length > count"
      call-on-mount
      selector="#components-layout-supplier-item #content-container"/>
  </div>
</template>
<script>
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'

/**
 * Блок работы с рейтингами поставщиков
  * @vue-data {Boolean} needSpr - Признак необходимости загрузки справочника типов оценок
  * @vue-data {Objecy} ratings - Объект работы с рейтингами
  * @vue-data {Objecy} supplierRatings - Данные с отзывами по поставщику
  * @vue-data {Boolean} ratingsLoading - Признак Загрузки данных по отзывам
 */
export default {
  name: 'supplierRating',
  data() {
    return {
      // typeRatings_sync: [],
      needSpr: true,
      supplierRatings: null,
      ratingsLoading: true,
      count: 0,
    }
  },
  methods: {
    infinityLoad() {
      if (this.count < this.ratingItems.length) {
        this.count = Math.min(this.ratingItems.length, this.count + this.per_page)
      }
    },
    /**
     * Получение рейтинга и данных справочника
     */
    async getRatings() {
      this.ratingsLoading = true
      if (this.needSpr) {
        await this.$store.dispatch('getRatingCriterias').then(res => {
          this.needSpr = false
          if (res?.length === 0) {
            return
          }
          this.typeRatings_sync = res.map(i => {
            return {
              id: i.id,
              criteriaName: i.criteriaName,
              criteriaShortName: i.criteriaShortName || `${i.criteriaName.substring(0, 7)}...`
            }
          })
        })
      }

      this.ratingsLoading = false
      await this.$store.dispatch('getSupplierRatings', {supplierOrgId: Number(this.organizationId)})
        .then(res => {
          this.ratingsLoading = false
          this.supplierRatings = res
          this.infinityLoad()
        })
    },
  },
  computed: {
    typeRatings_sync: {
      get() {
        return this.typeRatings
      },
      set(value) {
        this.$emit('update:typeRatings', value)
      }
    },
    sliced_items() {
      return this.ratingItems.slice(0, this.count)
    },
    per_page() {
      return Math.round(document.documentElement.clientHeight / 50 )
    },
    /** Заголовки таблицы */
    headers() {
      const colWidth = `(100% - ${((this.typeRatings_sync.length + 1) * 100) + 25}px)`
      const result = [
        { text: this.$t('Common.Date'), value: 'createDate', width: `calc(${colWidth}*0.3)`, sortable: true, align: 'start'},
        { text: this.$t('Suppliers.WhoEvaluated'), value: 'fullName', width: `calc(${colWidth}*0.7)`, sortable: true, align: 'start'},
        { text: this.$t('Suppliers.General'), value: 'totalScore', width: '100px', sortable: true, align: 'start'},
      ]
      this.typeRatings_sync.forEach(element => {
        result.push({ text: element.criteriaShortName, value: `rating${element.id}`, width: '100px', sortable: true, })
      })
      result.push({ text: '', value: 'remark', width: '25px', sortable: false, })
      return result
    },
    /* данные таблицы "Оцінка від моєї компанії"*/
    ratingItems() {
      if (!this.supplierRatings?.ratings.length) {
        return []
      }

      const result = []
      this.supplierRatings.ratings.forEach((rating) => {
        const row = {
          createDate: this.$moment(rating.createDate).format('DD.MM.YYYY'),
          fullName: rating.fullName,
          totalScore: rating.totalScore,
          remark: rating.remark
        }
        this.typeRatings_sync.forEach((typeRating) => {
          row[`rating${typeRating.id}`] = rating.evaluationCriterias.find(r => r.evaluationTypeTitle === typeRating.criteriaName)?.evaluationScore || '-'
        })
        result.push(row)
      })

      return result
    },
    /* данные "Оцінки в розрізі майданчику"*/
    evaluationCriterias() {
      const result = []

      this.typeRatings_sync.forEach((typeRating) => {
        const value = this.supplierRatings?.evaluationCriterias?.find(i => i.evaluationTypeTitle === typeRating.criteriaName)?.evaluationScore
        result.push({
          id: typeRating.id,
          title: typeRating.criteriaName,
          value: value ? this.$n(value, 'decimal') : '-'
        })
      })
      return result
    },
  },
  watch: {
    organizationId: {
      immediate: true,
      handler(newValue) {
        if (newValue) { this.getRatings() }
      }
    }
  },
  props: {
    typeRatings: {
      type: Array
    },
    itemRating: {
      type: [String, Number]
    },
    organizationId: {
      type: Number,
      require: true
    },
    organizationTitle: {
      type: String
    },
  },
  filters: {
    decimal_digits(value, digits, useGrouping = true) {
      if (isNaN(value) || value === undefined) { return value }
      if (typeof value !== 'number') {
        return value
      }
      const formatter = new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: digits,
        style: 'decimal',
        useGrouping
      })
      return formatter.format(value)
    }
  },
  components: {
    InfinityUpdater
  }
}
</script>
<style scoped>
.criteria-title {
  text-transform: uppercase;
  font-weight: 600;
}
.criteria-value {
  line-height: 48px;
  margin-top: 4px;
}
.criteria-value span:nth-child(1) {
  font-weight: 500;
  font-size: 48px;
}
.criteria-value span:nth-child(2) {
  font-weight: 600;
  font-size: 12px;
  opacity: 0.5;
  margin: 0 10px;
  text-transform: uppercase;
}
.criteria-value span:nth-child(3) {
  font-weight: 500;
  font-size: 27px;
  opacity: 0.5;
}
.criteria-evaluation {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  max-width: 49%;
  min-width: 49%;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-right: 8px;
  padding-left: 8px;
}
.criteria-evaluation-title {
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  line-height: 1.25;
  width: 100%;
  text-transform: uppercase;
}
.criteria-evaluation-value {
  font-size: 24px;
  font-weight: 700;
  text-align: left;
  height: 27px;
  width: 100%;
  margin-top: 4px;
}
</style>
